import React, { Component}  from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

import {MobileSidebar} from './components';

import {changeMobileMenu} from 'redux/actions/portal/system';
import {signOut} from '../../redux/actions/auth';

const mapStateToProps = (state) => ({
  menuOpen: state.system.get('toggleMobileMenu'),
  token: state.auth.get('token'),
  user: state.auth.get('user')
});

const mapDispatchToProps = (dispatch) => ({
  changeMobileMenu: () => dispatch(changeMobileMenu()),
  signOut: () => dispatch(signOut())
});

class Sidebar extends Component {

  componentDidMount() {
		if (window.innerWidth < 768 && this.props.menuOpen === true) {
			this.props.changeMobileMenu();
		}
	}

  // componentWillReceiveProps(nextProps) {
  //   if (this.props.location.pathname !== nextProps.location.pathname && window.innerWidth <1200) {
  //     if (this.props.menuOpen === true) {
  //       this.props.changeMobileMenu();
  //     }
  //   }
  // }

  render () {

    if (this.props.user === undefined) {
      return (
        <MobileSidebar open={this.props.menuOpen}>
          <ul>
            <div>
              <li onClick={this.props.changeMobileMenu}><Link to="/registration"><i className="fa fa-sign-in" aria-hidden="true"></i><span>Реєстрація</span></Link></li>
              <li onClick={this.props.changeMobileMenu}><Link to="/login"><i className="fa fa-sign-in" aria-hidden="true"></i><span>Вхід</span></Link></li>
            </div>

            <li onClick={this.props.changeMobileMenu}><Link to="/health-management">Департамент охорони здоров’я</Link></li>
            <li onClick={this.props.changeMobileMenu}><Link to="/news">Новини</Link></li>
            <li onClick={this.props.changeMobileMenu}><Link to="/infocenter">Інфоцентр</Link></li>
            <li onClick={this.props.changeMobileMenu}><Link to="/about">Про Портал</Link></li>
        </ul>
      </MobileSidebar>
      );
    }

    return (
      <MobileSidebar open={this.props.menuOpen}>
          <ul>
            {this.props.token ?

              (<div>
                <li onClick={this.props.changeMobileMenu}><Link to="/health-management">Департамент охорони здоров’я</Link></li>
                <li onClick={this.props.changeMobileMenu}><Link to="/news">Новини</Link></li>
                <li onClick={this.props.changeMobileMenu}><Link to="/infocenter">Інфоцентр</Link></li>
                <li onClick={this.props.changeMobileMenu}><Link to="/about">Про Портал</Link></li>

              </div>)
            :
            (
              <div>
                <li onClick={this.props.changeMobileMenu} style={{backgroundColor: "#aa8d19"}}><Link to="/registration">
                  <i className="fa fa-sign-in" aria-hidden="true"></i><span>Реєстрація</span>
                </Link></li>
                <li onClick={this.props.changeMobileMenu} style={{backgroundColor: "#aa8d19"}}><Link to="/login">
                  <i className="fa fa-sign-in" aria-hidden="true"></i><span>Вхід</span>
                </Link></li>
                <li onClick={this.props.changeMobileMenu}><Link to="/health-management">Департамент охорони здоров’я</Link></li>
                <li onClick={this.props.changeMobileMenu}><Link to="/news">Новини</Link></li>
                <li onClick={this.props.changeMobileMenu}><Link to="/infocenter">Інфоцентр</Link></li>
                <li onClick={this.props.changeMobileMenu}><Link to="/about">Про Портал</Link></li>
              </div>
            )}

            </ul>
      </MobileSidebar>
    );
  }
}

Sidebar.propTypes = {
  menuOpen: PropTypes.bool,
  changeMobileMenu: PropTypes.func
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar));



// WEBPACK FOOTER //
// ./src/system/header/mobile-sidebar.js